import React from "react";
import { Container } from "@mui/material";
import { List } from "./../../";
import { useTheme } from "@mui/material/styles";

function GlobalSearch(props) {
	const theme = useTheme();
	return (
		<Container
			maxWidth={theme?.customOptions?.containerMaxWidth || "xl"}
			sx={(theme) => ({ padding: theme.spacing(3, 0) })}
		>
			<List
				id={props.id}
				mode="list"
				showFilters
				hasDateRange={
					props.globalSearch && props.globalSearch.hasDateRange ? true : false
				}
				global
				cols={1}
			/>
		</Container>
	);
}

export default GlobalSearch;
